import React from "react";
import { Link } from "react-router";

import { version } from "../../../misc/version";

export const Version = () => (
  <div className="columns">
    <div className="column is-4 is-offset-4" style={{ textAlign: "center" }}>
      <img src="/images/logo-accent.png" width={200} height={200} />
      <h1>System version</h1>
      <p>{version}</p>
      <p><Link to="/">Click here to go home</Link></p>
    </div>
  </div>
);
